// Mock data for Pramal IT Services Landing Page

export const services = [
  {
    id: 1,
    title: "Product Engineering",
    description: "Web & mobile apps, MVPs, scalable platforms",
    icon: "Code2"
  },
  {
    id: 2,
    title: "AI & Automation",
    description: "AI workflows, RAG systems, internal tools, automation",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Low-Code / Rapid Development",
    description: "Fast delivery with modern low-code and full-code stacks",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Startup & MVP Execution",
    description: "Idea to launch with tech + product guidance",
    icon: "Rocket"
  },
  {
    id: 5,
    title: "Modernization & Optimization",
    description: "Legacy to modern, performance & UX improvements",
    icon: "RefreshCw"
  }
];

export const ventures = [
  {
    id: 5,
    name: "TikTym",
    description: "100 minutes a day for your goals, built for busy professionals",
    status: "Live",
    url: "https://www.tiktym.com"
  },
  {
    id: 1,
    name: "huesofred.com",
    description: "Brand, creative & content startup",
    status: "Active",
    url: "https://huesofred.com"
  },
  {
    id: 2,
    name: "PawBuddy",
    description: "Pet-focused product for pet parents",
    status: "In Progress",
    url: null
  },
  {
    id: 3,
    name: "CarPNP",
    description: "Airbnb-style car parking marketplace",
    status: "In Progress",
    url: null
  },
  {
    id: 4,
    name: "FounderZKit",
    description: "Toolkits & resources for founders",
    status: "Active",
    url: null
  }
];

export const tiktym = {
  name: "TikTym",
  tagline: "100 minutes a day for your productive life.",
  description:
    "A daily practice tracker for professionals with demanding jobs. Set aside time for exercise, reading, courses or meditation, and TikTym keeps you honest: missed minutes carry forward instead of disappearing, so a busy day never wipes out your progress.",
  websiteUrl: "https://www.tiktym.com",
  appUrl: "https://app.tiktym.com",
  highlights: ["Free, no ads", "Works offline", "Phone & laptop sync", "Data stored in India"],
  features: [
    {
      id: 1,
      title: "Voice logging with AI",
      description: "Say what you did; AI pulls out each practice and its minutes for you to confirm.",
      icon: "Mic"
    },
    {
      id: 2,
      title: "Focus timer",
      description: "Lights a bead per minute, keeps the screen awake and chimes at your target.",
      icon: "Timer"
    },
    {
      id: 3,
      title: "Backlog carry-forward",
      description: "Missed minutes roll over, capped at the number of days you choose.",
      icon: "CalendarClock"
    },
    {
      id: 4,
      title: "Streaks & shields",
      description: "Three clear days earn a shield that protects your streak on an off day.",
      icon: "ShieldCheck"
    },
    {
      id: 5,
      title: "Insights & coaching",
      description: "Best and weakest days, week-over-week trends and plain-language coaching.",
      icon: "TrendingUp"
    },
    {
      id: 6,
      title: "Offline & multi-device",
      description: "Log without a connection; it syncs across phone and laptop later.",
      icon: "WifiOff"
    }
  ]
};

export const whyPramal = [
  {
    id: 1,
    title: "Founder-led execution",
    icon: "User"
  },
  {
    id: 2,
    title: "Product mindset, not body-shopping",
    icon: "Target"
  },
  {
    id: 3,
    title: "Practical, build-first approach",
    icon: "Hammer"
  },
  {
    id: 4,
    title: "Experience with startups & real products",
    icon: "Briefcase"
  },
  {
    id: 5,
    title: "Speed without sacrificing quality",
    icon: "Gauge"
  }
];

export const engagementSteps = [
  {
    id: 1,
    step: "01",
    title: "Understand the problem",
    description: "We dig deep to understand your vision and goals."
  },
  {
    id: 2,
    step: "02",
    title: "Build fast, iterate smarter",
    description: "Rapid development with continuous feedback."
  },
  {
    id: 3,
    step: "03",
    title: "Scale with confidence",
    description: "Launch and grow with solid foundations."
  }
];

export const founderNote = {
  quote: "Pramal IT Services brings practical, hands-on product thinking to businesses that want to move fast and build right.",
  name: "Founder, Pramal IT Services"
};
